module.exports = __webpack_public_path__ + "static/media/curriculum.f0b024a1.svg";